import { DraftReturnSchema } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import {
  CreateDraftReturnFromOrderInputSchema,
  CreateDraftReturnFromProductsInputSchema,
  CreateDraftReturnFromWarrantyRegistrationInputSchema,
} from "./create-draft-return-from-source";

const CreateOrderlessDraftReturnInputSchema = z
  .object({
    ...CreateDraftReturnFromWarrantyRegistrationInputSchema.shape,
    ...CreateDraftReturnFromProductsInputSchema.shape,
  })
  .omit({ source: true });

export const createDraftReturn = {
  name: "createDraftReturn" as const,
  input: CreateDraftReturnFromOrderInputSchema.omit({ source: true }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};

export const createOrderlessDraftReturn = {
  name: "createOrderlessDraftReturn" as const,
  input: CreateOrderlessDraftReturnInputSchema,
  output: z.object({ draftReturn: DraftReturnSchema }),
};

export const addProductToOrderlessDraftReturn = {
  name: "addProductToOrderlessDraftReturn" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    productIds: z.array(z.string()),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
